/**
 * Teammate calendars offered in Unified Calendar (CRM) multi-select and Meridian tools.
 * Single source of truth for the fixed allowlist — keep in sync with product expectations.
 */
export const UNIFIED_CALENDAR_SHARED_TEAM_CALENDARS = [
  {
    slug: "eliza_keffeler",
    email: "eliza.keffeler@westtn.consulting",
    label: "Eliza Keffeler",
  },
  {
    slug: "charlie_keffeler",
    email: "charlie.keffeler@westtn.consulting",
    label: "Charlie Keffeler",
  },
  {
    slug: "jimmy_turner",
    email: "jimmytreb@gmail.com",
    label: "Jimmy Turner",
  },
  {
    slug: "miclain_keffeler",
    email: "miclainkeffeler@westtn.consulting",
    label: "Miclain Keffeler",
  },
] as const;

export type UnifiedCalendarSharedTeamSlug =
  (typeof UNIFIED_CALENDAR_SHARED_TEAM_CALENDARS)[number]["slug"];

const _teamSlugs = UNIFIED_CALENDAR_SHARED_TEAM_CALENDARS.map((r) => r.slug);
if (_teamSlugs.length < 1) {
  throw new Error("UNIFIED_CALENDAR_SHARED_TEAM_CALENDARS must not be empty");
}

/** Tuple for Zod `z.enum()` — derived from {@link UNIFIED_CALENDAR_SHARED_TEAM_CALENDARS}. */
export const UNIFIED_CALENDAR_TEAM_SLUG_ENUM = _teamSlugs as [
  UnifiedCalendarSharedTeamSlug,
  ...UnifiedCalendarSharedTeamSlug[],
];

export function getUnifiedCalendarSharedTeamEmail(slug: UnifiedCalendarSharedTeamSlug): string {
  const row = UNIFIED_CALENDAR_SHARED_TEAM_CALENDARS.find((r) => r.slug === slug);
  if (!row) {
    throw new Error(`Unknown unified calendar team slug: ${String(slug)}`);
  }
  return row.email;
}

/** Options shaped for CalendarMultiSelector (`value` = calendar identity email). */
export function getUnifiedCalendarSharedTeamPickerOptions(): Array<{
  value: string;
  label: string;
}> {
  return UNIFIED_CALENDAR_SHARED_TEAM_CALENDARS.map((r) => ({
    value: r.email,
    label: r.label,
  }));
}

/** Short slug → display name (for tool / prompt copy). */
export function getUnifiedCalendarSharedTeamLabel(slug: UnifiedCalendarSharedTeamSlug): string {
  const row = UNIFIED_CALENDAR_SHARED_TEAM_CALENDARS.find((r) => r.slug === slug);
  if (!row) {
    throw new Error(`Unknown unified calendar team slug: ${String(slug)}`);
  }
  return row.label;
}

/** Comma-separated tool slugs — use in capability copy so it stays in sync with the allowlist. */
export function getUnifiedCalendarSharedTeamSlugsForDocs(): string {
  return UNIFIED_CALENDAR_SHARED_TEAM_CALENDARS.map((r) => r.slug).join(", ");
}
